import styled from 'styled-components';
import { Form, FormGroup } from 'react-bootstrap';

export const StyledFilterWrapper = styled(Form)`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    .csv-link-button {
      display: none;
    }
    justify-content: space-between;
  }
`;

export const StyledFilterFormGroup = styled(FormGroup)`
  &&& {
    padding-left: 0;
    width: 250px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 20px;
    margin-bottom: 15px;

    @media (max-width: 768px) {
      width: 120px;
      margin-bottom: 8px;
      margin-right: 10px;
    }
  }
`;

export const StyledFilterTitle = styled.h4`
  @media (min-width: 769px) {
    display: none;
  }
  margin: 0;
  margin-bottom: 20px;

  font-size: 18px;
`;

export const StyledFilterCheckbox = styled(FormGroup)`
  &&& {
    display: inline-block;
    vertical-align: top;
    margin-top: 8px;
    margin-left: 16px;
    margin-bottom: 15px;

    @media (max-width: 768px) {
      margin-left: 0;
    }
  }
`;

export const StyledFilterDateField = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;
